"use strict";
exports.__esModule = true;
exports.persianToEnglish = void 0;
var persianToEnglish = function (str) {
    // @ts-ignore
    return str.replace(/[۰-۹]/g, function (d) { return '۰۱۲۳۴۵۶۷۸۹'.indexOf(d); });
};
exports.persianToEnglish = persianToEnglish;
//# sourceMappingURL=persian-to-english-number.js.map